/**
 * Minimal HTML hardening for entry bodies: removes script/style/embedding elements, inline
 * event handlers, and `javascript:` URLs before injecting into the DOM.
 *
 * This is a stopgap appropriate while content is authored by us. When entry bodies become
 * remote/user-generated, replace this with a vetted sanitizer (e.g. DOMPurify). See DESIGN.md.
 */
export function setSafeHtml(target: HTMLElement, html: string): void {
  const tpl = document.createElement('template');
  tpl.innerHTML = html;

  tpl.content.querySelectorAll('script, style, iframe, object, embed, link, meta').forEach(node => node.remove());

  tpl.content.querySelectorAll('*').forEach(node => {
    for (const attr of Array.from(node.attributes)) {
      const name = attr.name.toLowerCase();
      const value = attr.value.replace(/\s+/g, '').toLowerCase();
      if (name.startsWith('on')) {
        node.removeAttribute(attr.name);
      } else if ((name === 'href' || name === 'src' || name === 'xlink:href') && value.startsWith('javascript:')) {
        node.removeAttribute(attr.name);
      }
    }
  });

  target.replaceChildren(tpl.content);
}

/** Extract collapsed plain text from an HTML string (for previews / excerpts). */
export function htmlToText(html: string): string {
  const tpl = document.createElement('template');
  tpl.innerHTML = html;
  return (tpl.content.textContent ?? '').replace(/\s+/g, ' ').trim();
}
